import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils } from 'versafleet-core';
import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';

const { Helper, RequestHelper } = Utils;

function WithRouterHooks(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  return <Tracking {...props} location={location} navigate={navigate} params={params} />;
}

class Tracking extends React.Component {
  constructor(props) {
    super(props);
    const { state } = props.location;
    this.state = {
      error: (state && state.error) || [],
      form: {
        trackingNumber: (state && state.trackingNumber) || '',
      },
    };
    // Treat the special value 'all' as no domain so
    // the app uses the general tracking endpoints (/tasks/...) instead
    // of account-specific endpoints (/accounts/:domain/...).
    this.domain = props.params.domain && props.params.domain !== 'all'
      ? props.params.domain
      : null;
  }

  componentDidMount() {
    document.title = this.domain ? `${this.domain} Tracking` : 'Tracking';
    if (!Helper.isNullOrUndefined(this.domain)) {
      this._getLogo();
    }

    const { location, navigate } = this.props;
    if (!Helper.isNullOrUndefined(location.state)) {
      navigate(location.pathname, { replace: true });
    }
  }

  _getLogo = async () => {
    try {
      const data = await RequestHelper.request(`/accounts/${this.domain}/get_logo`, { method: 'GET' });
      this.setState({ logoUrl: data.logo_url });
    } catch (error) {
      console.warn('Error fetching logo:', error);
    }
  }

  _getTrackingStatus = async () => {
    const { form, logoUrl } = this.state;
    const { navigate } = this.props;
    const trackingNumber = form.trackingNumber.replace(/\s/g, '');

    this.setState({ error: [] });
    const url = !Helper.isNullOrUndefined(this.domain)
      ? `/accounts/${this.domain}/tasks/${trackingNumber}/track`
      : `/tasks/${trackingNumber}/track`;

    if (!Helper.isNullOrUndefined(trackingNumber) && trackingNumber !== '') {
      try {
        const data = await RequestHelper.request(url,
          { method: 'POST' });

        const pathname = !Helper.isNullOrUndefined(this.domain)
          ? `/${this.domain}/${trackingNumber}`
          : `/all/${trackingNumber}`;

        navigate(
          pathname,
          {
            state: {
              data,
              logoUrl,
            },
          },
        );
      } catch (error) {
        this.setState({ error });
      }
    }
  }

  _onFormChange(fieldName, value) {
    const { form } = this.state;
    this.setState({
      form: Helper.setFilter(form, fieldName, value),
    });
  }

  _renderLogo() {
    const { logoUrl } = this.state;
    return (
      <img alt="Logo" className="vf-tracking__container__logo" src={logoUrl} />
    );
  }

  render() {
    const { error, form, logoUrl } = this.state;

    return (
      <div className="vf-tracking">
        <Components.Container
          className="vf-tracking__container"
        >
          {Helper.isNullOrUndefined(logoUrl) || logoUrl === '' ? false : this._renderLogo()}
          <div className="vf-tracking__container__description">
            <div className="vf-tracking__container__description__header">
              Track your order
            </div>
            <div className="vf-tracking__container__description__detail">
              Enter the Tracking ID below
            </div>
          </div>
          <Components.Input.Textbox
            error={error}
            id="vf-tracking__container__tracking-textbox"
            onChange={value => this._onFormChange('trackingNumber', value)}
            onEnterKeyPressed={this._getTrackingStatus}
            placeholder="Tracking ID"
            value={form.trackingNumber}
            width={Components.Input.Width.FULL}
          />
          <Components.Button
            className="vf-tracking__container__form-button"
            id="vf-tracking__submit-button"
            onClick={this._getTrackingStatus}
          >
            Track my order
          </Components.Button>
        </Components.Container>
      </div>
    );
  }
}

Tracking.displayName = 'Tracking';

Tracking.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.shape({
      error: PropTypes.arrayOf(PropTypes.string),
      trackingNumber: PropTypes.string,
    }),
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  params: PropTypes.shape({
    domain: PropTypes.string,
  }).isRequired,
};

export default WithRouterHooks;
